import { PropsWithChildren } from 'react';
import { Drawer, DrawerContent } from '@progress/kendo-react-layout';
import { BackupReminder, CloseButton, DisputeButton } from 'components';
import { AdjustmentDetail, InvoiceDetail, PaymentDetail } from 'types';
import { getAdjustmentTypeLabel } from 'functions';
import styles from './AdjustmentDetailSidebar.module.scss';

export type AdjustmentDetailSidebarProps = {
    allowDispute?: boolean,
    selectedDetail: AdjustmentDetail,
    setSelectedDetails: ((value: PaymentDetail[] ) => void) | ((value: InvoiceDetail[] ) => void),
    expanded: boolean,
    setExpanded: (value: boolean) => void,
    disableDisputeButton?: boolean,
    selectedDetailsForDispute?: AdjustmentDetail[]
};

export const AdjustmentDetailSidebar = (props: PropsWithChildren<AdjustmentDetailSidebarProps>) => {
    const {
        allowDispute = true,
        children,
        selectedDetail,
        setSelectedDetails,
        expanded,
        setExpanded,
        disableDisputeButton,
        selectedDetailsForDispute
    } = props;

    const handleCloseButton = () => {
        setExpanded(false);
        setSelectedDetails([]);
    };
    
    const title = getAdjustmentTypeLabel(selectedDetail.adjustmentTypeId);

    return (
        <Drawer
            className={styles.drawer}
            expanded={expanded}
            position="start"
        >
            <DrawerContent className={styles.content}>
                <div className={styles.header}>
                    <div className={styles.heading}>{title}</div>
                    <CloseButton onClick={() => handleCloseButton()} />
                </div>
                <div className={styles.body}>
                    {children}
                </div>
                {allowDispute &&
                    <div className={styles.footer}>
                        <BackupReminder/>   
                        <DisputeButton 
                            selectedDetails={selectedDetailsForDispute ?? [selectedDetail]}
                            disabled={disableDisputeButton}
                        />
                    </div>
                }
            </DrawerContent>
        </Drawer>
    );
};
